/*
 * @Author: gujianghua
 * @Date:   2018-07-21 18:00:58
 * @Last Modified by:   gujianghua
 * @Last Modified time: 2020-09-22 14:22:51
 */
import {
  service,
  BASE_API
} from '@/utils/request'

export default {
  //分页获取课程源列表
  getCourseSourceList: (data) => {
    return service({
      url: '/cloud/course/v1/admin/coursesource/pageList',
      method: 'post',
      data: data
    })
  },
  //根据课程源id获取关联的课程列表
  getRelateCourseList: (params) => {
    return service({
      url: '/cloud/course/v1/admin/coursesource/associationCourseList',
      method: 'get',
      params: params
    })
  },
  //更改上下架状态
  changeStatus(params) {
    return service({
      url: '/cloud/course/v1/admin/coursesource/offline',
      method: 'post',
      params: params
    })
  },
  //删除课程源
  deleteCourse(params) {
    return service({
      url: '/cloud/course/v1/admin/coursesource/delete',
      method: 'post',
      params: params
    })
  },
  //获取所有标签分组（不含分组内的具体标签）
  getTagCategoryList: () => {
    return service({
      url: '/cloud/course/v1/admin/tag/category/tagCategoryList',
      method: 'get',
    })
  },
  //根据标签分组id获取分组内的标签
  getTagListByCategory: (params) => {
    return service({
      url: '/cloud/course/v1/admin/tag/category/tagListByCategory',
      method: 'get',
      params: params
    })
  },
  //增加课程源
  addCourseSource: (data) => {
    return service({
      url: '/cloud/course/v1/admin/coursesource/create',
      method: 'post',
      data: data
    })
  },
  //根据课程源id获取详情
  getCourseDetailById: (params) => {
    return service({
      url: '/cloud/course/v1/admin/coursesource/findById',
      method: 'get',
      params: params
    })
  },
  //修改课程
  editCourseSource: (data) => {
    return service({
      url: '/cloud/course/v1/admin/coursesource/modify',
      method: 'post',
      data: data
    })
  },
  getSignatureUrl: () => {
    return BASE_API + '/cloud/uac/proxy/Common/GetVodUploadSign';
  },
  //获取视频转码状态
  getTranscodeInfoApi: (params) => {
    return service({
      url: '/cloud/course/v1/admin/coursesource/video/transcodeInfo',
      method: 'get',
      params: params
    })
  },
  //获取课件-已绑定
  getCoursePic: (params) => {
    return service({
      url: '/cloud/course/v1/admin/coursesource/getBindingCoursewareList',
      method: 'get',
      params: params
    })
  },
  //获取课件-未绑定
  getCoursePic_add: (params) => {
    return service({
      url: '/cloud/course/v1/admin/live/courseWare/list',
      method: 'get',
      params: params
    })
  },
  // 添加标签
  addBatchTag: function addBatchTag(data) {
    return service({
      url: '/cloud/course/v1/admin/tag/category/addBatchTag',
      method: 'post',
      data: data
    })
  },
  // 获取标签明细
  getTags(data) {
    return service({
      url: '/cloud/course/v1/admin/tag/category/tagListByCategoryPage',
      method: 'get',
      params: data
    })
  },
  // 修改课程源fileId
  modifyFileId(data) {
    return service({
      url: '/cloud/course/v1/admin/coursesource/modifyFileId',
      method: 'post',
      data: data
    })
  },
  // 修改课程源fileId
  switchKnowledge(params) {
    return service({
      url: '/cloud/course/v1/admin/coursesource/knowledge',
      method: 'post',
      params
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/contentManage/courseSource.js